module.exports = "/_next/static/images/CreateOneCustomerConversation-e9c4d985b36021e6bad7750c0006e5a7.webp";